import React from 'react';
import ReactGA from 'react-ga';
import { Route, Switch, withRouter, Redirect } from 'react-router-dom';
import App from '@/pages/Main';
import Conf from '@/pages/ConfLanding';
import MainWrapper from '@/components/MainWrapper';
import {mainUrl, paradigmUrl, extendedPages} from '@/pages/configPages';
import PageNotFound from '@/pages/PageNotFound';

const NestedRoutes = ({url, component, childrens}) => (
    <Switch>
        <Route exact path={url} component={component} />

        {
            childrens.map(({url, component}) => <Route exact key={url} path={url} component={component} />)
        }

        <Route component={PageNotFound} />
    </Switch>
);

class Routing extends React.Component {

    componentWillMount() {
        this.unlisten = this.props.history.listen((location) => {
            ReactGA.pageview(location.pathname);
        });
    }
    componentWillUnmount() {
        this.unlisten();
    }

    render() {
        return (
            <Switch>
                <Route strict path={'/conf'} component={Conf} />

                <MainWrapper>
                    <Switch>
                        <Route exact path={mainUrl} component={App} />
                        <Redirect from={paradigmUrl} to={mainUrl} />

                        {
                            extendedPages.map(({url, component, childrens}) => {
                                if (childrens) {
                                    return (
                                        <Route
                                            key={url}
                                            path={url}
                                            component={() => <NestedRoutes url={url} component={component} childrens={childrens} />}
                                        />
                                    );
                                }

                                return (
                                    <Route path={url} component={component} key={url} />
                                )
                            })
                        }

                        <Route component={PageNotFound} />
                    </Switch>
                </MainWrapper>
            </Switch>
        );
    }
}

export default withRouter(Routing);